// Type for YAML-based labels
export interface YamlLabel {
  id: string;
  slug: string;
  name: string;
}

export default class Label {
  id: string;
  slug: string;
  name: string;

  constructor(label: YamlLabel) {
    this.id = label.id;
    this.slug = label.slug!;
    this.name = label.name!;
  }
}
